<template>
  <div class="component-content sub-content">
    <!-- <div class="list-title">
      
      <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div> -->
    <div class="list-title">
      <div class="r">
        <router-link :to="'/Storage/MaterialIn/'+houseId">
          <el-button type="success" size="mini">材料入库登记</el-button>
        </router-link>

        <a :href="baseURL+'/storage/material/stock/download?depId='+(depId==0?'':depId)+'&houseId='+(houseId?houseId:'')"
          target="_blank">
          <el-button type="primary" size="mini">材料盘点实时库存表下载</el-button>
        </a>
      </div>
      <el-row>
        <el-col class="item-select" :span="5">
          <label class="label-name">当前仓库：</label>
          <el-select size="mini" v-model="houseId" placeholder="请选择仓库">
            <el-option v-for="item in houseList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col class="item-input" :span="8">
          <label>搜索：</label>
          <el-input v-model="filterKey" size="mini" placeholder="你可以搜索材料明细名称/材料编号"></el-input>
        </el-col>
      </el-row>
    </div>

    <div class="table-total">
      <span>材料实时库存合计数量：{{ total.sl }} 件</span>
      <!-- <span>总金额：{{ total.zj }} 元</span> -->
    </div>
    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="material.number" label="材料编号" width="80">
      </el-table-column>
      <el-table-column prop="material.name" label="明细名称">
      </el-table-column>
      <el-table-column prop="material.spec" align="left" width="150" label="规格型号">
      </el-table-column>
      <el-table-column prop="material.dl.name" label="材料类别" width="150" align="left">
      </el-table-column>
      <!-- <el-table-column prop="supplier.name" label="供应商">
      </el-table-column> -->
      <el-table-column prop="material.unit.name" width="80" align="center" label="计量单位">
      </el-table-column>
      <el-table-column  align="center" width="80" label="当前库存">
        <template slot-scope="scope">
          {{ scope.row.amount && parseFloat(scope.row.amount).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="price" align="center" width="80" label="当前单价(元)">
        <!-- <template slot-scope="scope">
          {{ scope.row.amount && parseFloat(scope.row.amount).toFixed(2) }}
        </template> -->
      </el-table-column>
    </el-table>

    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Role from '@/Mixins/role'
  export default {
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
        managerStorage: state => state.storage.managerStorage,
      })
    },
    data() {
      return {
        baseURL: axios.defaults.baseURL,


        houseId: "",
        depId: "",
        houseList: "",
        allHouseList: [],

        organizationListData: [],
        noSelectOrganization: true,
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        filterKey: "",

        // 合计
        total: {},
      }
    },
    created() {
      if (this.$route.params.houseId) {
        this.houseId = this.$route.params.houseId / 1
      }
      this.depId = this.userData.secDepIds.split(",")[0] / 1
      // 获取仓库列表
      this.getHouseList()
    },
    mounted() {
      // 如果不是仓库管理员，跳转至材料领用页面
      // if (this.managerStorage.length < 1) {
      //   this.$router.push('/Storage/MaterialUseList')
      // }

      this.organizationListData = this.organization[0].childDepts

      if (this.userData.secDepIds.split(",")[0] == "7") {
        this.noSelectOrganization = false
      }
    },
    methods: {
      // 获取所有仓库
      getAllHouse(cb) {
        // 获取所有仓库
        ajax.get('/storage/house/list', {
          'depId': '' //this.form.depId
        }, (res) => {
          this.allHouseList = res.vo.array
          cb && cb()
        })
      },
      // 获取仓库列表
      getHouseList() {
        this.houseList = this.managerStorage

        if (this.backRole('ST_13')) {
          this.getAllHouse(() => {
            this.houseList = this.allHouseList

            if (!this.houseId && this.houseList.length > 0) {
              this.houseId = this.houseList[0].id
            }
            // 获取库存
            this.getLists()
          })
        } else {
          if (this.houseList.length < 1) {
            this.$message.error('您暂无可以查看库存权限的仓库')
            this.loading = false
            return
          }
          if (!this.houseId && this.houseList.length > 0) {
            this.houseId = this.houseList[0].id
          }
          // 获取库存
          this.getLists()
        }



      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.material.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 || _new.material.number
              .toLowerCase().indexOf(this.filterKey.toLowerCase()) != -
              1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        this.filterKey = ''

        // if (!this.houseId && this.houseList.length > 0) {
        //   this.houseId = this.houseList[0].id
        // }
        this.loading = true

        ajax.get('/storage/material/realTime/list', {
          depId: this.depId,
          "houseId": this.houseId == 0 ? '' : this.houseId
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.items
          this.total = {
            sl: res.vo.slTotal,
            zj: res.vo.zjTotal
          }
          this.getFilterData()
        })
      },
    },
    watch: {
      depId() {
        this.getLists()
      },
      houseId() {
        this.getLists()
      },
      filterKey() {
        this.getFilterData()
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/storage/roomDetail.vue